export default "__VITE_ASSET__e07f402b__"